import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    selector: "error-message",
    templateUrl: "./error-message.component.html",
    styleUrls: ["./error-message.component.less"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class ErrorMessageComponent {
  @Input() message?: string;
}


